// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kcQO","footer":"styles_footer__3PTqC"};